import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <i className="ri-smartphone-line text-2xl text-accent-500"></i>
              <span className="font-semibold text-foreground-950">体育App指南</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              致力于为中国体育爱好者提供最专业、最全面的体育App推荐与下载指南，帮助您找到最适合的体育应用。
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-950 mb-4 text-sm">
              <a href="#footer-categories" className="hover:text-accent-600 transition-colors">热门分类</a>
            </h4>
            <ul className="space-y-2">
              <li><Link to="/category/saishi-zhibo" className="text-sm text-foreground-600 hover:text-accent-600 transition-colors whitespace-nowrap">赛事直播App</Link></li>
              <li><Link to="/category/yundong-jilu" className="text-sm text-foreground-600 hover:text-accent-600 transition-colors whitespace-nowrap">运动记录App</Link></li>
              <li><Link to="/category/jingcai-hudong" className="text-sm text-foreground-600 hover:text-accent-600 transition-colors whitespace-nowrap">竞猜互动App</Link></li>
              <li><Link to="/category/tiyu-zixun" className="text-sm text-foreground-600 hover:text-accent-600 transition-colors whitespace-nowrap">体育资讯App</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-950 mb-4 text-sm">
              <a href="#footer-articles" className="hover:text-accent-600 transition-colors">精选文章</a>
            </h4>
            <ul className="space-y-2">
              <li><Link to="/article/1" className="text-sm text-foreground-600 hover:text-accent-600 transition-colors">体育直播App对比</Link></li>
              <li><Link to="/article/2" className="text-sm text-foreground-600 hover:text-accent-600 transition-colors">跑步App推荐</Link></li>
              <li><Link to="/article/3" className="text-sm text-foreground-600 hover:text-accent-600 transition-colors">足球迷必装App</Link></li>
              <li><Link to="/article/5" className="text-sm text-foreground-600 hover:text-accent-600 transition-colors">NBA观赛指南</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-950 mb-4 text-sm">
              关于
            </h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-accent-600 transition-colors whitespace-nowrap">关于我们</Link></li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-accent-100 hover:text-accent-600 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-accent-100 hover:text-accent-600 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 体育App指南. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">用户协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}